import styled from "@emotion/styled";
import { Text } from "@otrium/atoms";

export const StyledText = styled(Text)`
  font-size: 16px;
  color: white;
`;
